import * as React from "react"

function BasicContentCMS(props) {
  return (
    <svg
      id="basic-content-cms_Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 565.692 341.058"
      {...props}
    >
      <defs>
        <style>
          {
            ".basic-content-cms_cls-2{fill:#fff}.basic-content-cms_cls-3{fill:#e9ecef}.basic-content-cms_cls-4{fill:#00aeef}.basic-content-cms_cls-5{opacity:.3}.basic-content-cms_cls-6{fill:none;stroke:#e9ecef;stroke-miterlimit:10}.basic-content-cms_cls-7{fill:#c1c6cb}.basic-content-cms_cls-8{fill:#00bcd4}.basic-content-cms_cls-9{fill:#1eca8a}"
          }
        </style>
      </defs>
      <path
        d="M576 300.379c-33.653 38.722-88.67 8.47-228.054 13.684-181.794 6.8-231.608 63.624-277.574 26.063-75.772-61.92-33.345-292.29 61.248-325.14 26.127-9.073 40.572 2.362 102.3 20.2 183.84 53.126 247.137 7.012 308.2 63.856C598.471 151.5 614.589 255.977 576 300.379z"
        transform="translate(-31.406 -11.802)"
        fill="#efc621"
      />
      <path className="basic-content-cms_cls-2" d="M27.402 32.688h500v250h-500z" />
      <path
        className="basic-content-cms_cls-2"
        d="M64.573 55.972h137.515a3.715 3.715 0 013.715 3.715v15.894a3.715 3.715 0 01-3.715 3.715H64.573a3.716 3.716 0 01-3.716-3.716V59.688a3.716 3.716 0 013.716-3.716z"
      />
      <path
        className="basic-content-cms_cls-3"
        d="M233.494 68.274a3.219 3.219 0 013.215 3.216v15.893a3.219 3.219 0 01-3.215 3.216H95.979a3.22 3.22 0 01-3.216-3.216V71.49a3.22 3.22 0 013.216-3.216h137.515m0-1H95.979a4.228 4.228 0 00-4.216 4.216v15.893a4.228 4.228 0 004.216 4.217h137.515a4.228 4.228 0 004.215-4.216V71.49a4.228 4.228 0 00-4.215-4.216z"
        transform="translate(-31.406 -11.802)"
      />
      <path
        className="basic-content-cms_cls-4"
        d="M233.709 91.6h-20.324V67.274h20.324a4.012 4.012 0 014 4V87.6a4.012 4.012 0 01-4 4z"
        transform="translate(-31.406 -11.802)"
      />
      <rect
        className="basic-content-cms_cls-4"
        x={216.73}
        y={55.472}
        width={32.096}
        height={24.324}
        rx={4}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={60.357}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={64.348}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={131.163}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={135.154}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={201.968}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={205.959}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={272.773}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={276.764}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={343.578}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={347.569}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={414.384}
          y={93.698}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={418.375}
        y={97.913}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <g className="basic-content-cms_cls-5">
        <rect
          className="basic-content-cms_cls-4"
          x={60.357}
          y={119.327}
          width={64.812}
          height={18.519}
          rx={4.96}
        />
      </g>
      <rect
        className="basic-content-cms_cls-4"
        x={64.348}
        y={123.542}
        width={11.518}
        height={10.089}
        rx={1.543}
      />
      <rect
        className="basic-content-cms_cls-4"
        x={259.253}
        y={55.472}
        width={52.87}
        height={24.324}
        rx={4}
      />
      <rect
        className="basic-content-cms_cls-2"
        x={361.02}
        y={55.972}
        width={132.926}
        height={23.324}
        rx={3.5}
      />
      <path
        className="basic-content-cms_cls-3"
        d="M521.852 68.274a3 3 0 013 3V87.6a3 3 0 01-3 3H395.926a3 3 0 01-3-3V71.274a3 3 0 013-3h125.926m0-1H395.926a4.012 4.012 0 00-4 4V87.6a4.012 4.012 0 004 4h125.926a4.012 4.012 0 004-4V71.274a4.012 4.012 0 00-4-4z"
        transform="translate(-31.406 -11.802)"
      />
      <path
        className="basic-content-cms_cls-6"
        d="M383.685 55.472V79.19M405.404 55.472V79.19M427.124 55.472V79.19M448.843 55.472V79.19M470.562 55.472V79.19"
      />
      <rect
        className="basic-content-cms_cls-2"
        x={60.857}
        y={149.926}
        width={433.088}
        height={109.478}
        rx={3.5}
      />
      <path
        className="basic-content-cms_cls-3"
        d="M521.852 162.229a3 3 0 013 3v102.477a3 3 0 01-3 3H95.763a3 3 0 01-3-3V165.229a3 3 0 013-3h426.089m0-1H95.763a4.012 4.012 0 00-4 4v102.477a4.012 4.012 0 004 4h426.089a4.012 4.012 0 004-4V165.229a4.012 4.012 0 00-4-4z"
        transform="translate(-31.406 -11.802)"
      />
      <path
        className="basic-content-cms_cls-6"
        d="M78.527 149.426v110.478M60.357 169.063h434.089M60.357 204.665h434.089M60.357 240.267h434.089M277.402 149.426v110.478M350.454 149.426v110.478M427.483 149.426v110.478"
      />
      <path
        className="basic-content-cms_cls-7"
        d="M66.364 155.506h8.253v8.253h-8.253zM66.364 182.737h8.253v8.253h-8.253zM66.364 218.34h8.253v8.253h-8.253zM66.364 252.901h8.253v5.81h-8.253zM293.822 155.506h39.549v8.253h-39.549zM287.697 182.737h52.463v8.253h-52.463zM375.984 155.506h27.824v8.253h-27.824zM375.984 190.294h27.824v8.253h-27.824zM440.491 155.506h37.501v8.253h-37.501zM110.486 155.506h134.957v8.253H110.486zM85.074 175.923h150.763v8.253H85.074z"
      />
      <path
        className="basic-content-cms_cls-8"
        d="M85.074 190.294h75.382v8.253H85.074z"
      />
      <circle className="basic-content-cms_cls-9" cx={389.896} cy={182.954} r={5.294} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={183.579} r={1.357} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={187.923} r={1.357} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={192.267} r={1.357} />
      <path
        className="basic-content-cms_cls-7"
        d="M285.215 217.969h56.764v8.253h-56.764zM375.984 225.525h27.824v8.253h-27.824zM85.074 211.154H222.31v8.253H85.074z"
      />
      <path
        className="basic-content-cms_cls-8"
        d="M85.074 225.525h75.382v8.253H85.074z"
      />
      <circle className="basic-content-cms_cls-9" cx={389.896} cy={218.186} r={5.294} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={218.81} r={1.357} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={223.154} r={1.357} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={227.498} r={1.357} />
      <path
        className="basic-content-cms_cls-7"
        d="M291.091 253.2h45.675v5.511h-45.675zM85.074 246.385h166.904v8.253H85.074z"
      />
      <circle className="basic-content-cms_cls-9" cx={389.896} cy={253.417} r={5.294} />
      <circle className="basic-content-cms_cls-7" cx={459.241} cy={254.041} r={1.357} />
      <path
        className="basic-content-cms_cls-7"
        d="M492.005 270.188h-2.715a1.358 1.358 0 112.715 0z"
        transform="translate(-31.406 -11.802)"
      />
    </svg>
  )
}

export default BasicContentCMS
